__turbopack_context__.v({
  "className": "bebas_neue_2f551e88-module__lmpbGq__className",
});
